import * as apifetch from './fetch.js';

export async function getBrandData(brand) {
    const urlEndpoint = '/adam/getBrandData.php';

    const postData = {
        brand: brand
    };

    return apifetch.adamFetch(urlEndpoint, 'POST', postData)
}


export async function getDataCarousel(section) {
    const urlEndpoint = '/adam/getDataCarousel.php';

    const postData = {
        section: section
    };

    return apifetch.adamFetch(urlEndpoint, 'POST', postData)
}


